import { normalizeIntegrationError } from "./integrationErrors";
import { logIntegrationError } from "../../utils/integrationLogger";

export function handleIntegrationError(error, options = {}) {
  const {
    openModal,
    flow = "consulta",
    service = "recaudo-api",
    endpoint,
    refPayco,
    onFinally,
    modalType = "warning",
    setState,
    stateUpdates = { loading: false },
  } = options;

  const integrationError = normalizeIntegrationError(error, {
    endpoint,
    backendMessage: options.backendMessage,
    statusCode: options.statusCode,
  });

  if (options.userMessage) {
    integrationError.userMessage = options.userMessage;
  }

  logIntegrationError({
    flow,
    service,
    endpoint: endpoint || integrationError.endpoint,
    errorType: integrationError.errorType,
    statusCode: integrationError.statusCode,
    refPayco,
  });

  if (setState) {
    setState(stateUpdates);
  }

  if (onFinally) {
    onFinally(integrationError);
  }

  if (openModal) {
    openModal(integrationError.userMessage, modalType);
  }

  return integrationError;
}

export function reportPagoError(component, error, options = {}) {
  return handleIntegrationError(error, {
    openModal: component.props.openModal,
    flow: "pago",
    service: options.service || "recaudo-api",
    endpoint: options.endpoint,
    backendMessage: options.backendMessage,
    userMessage: options.userMessage,
    setState: (updates) => component.setState(updates),
    stateUpdates: { loading: false, ...(options.stateUpdates || {}) },
    modalType: options.modalType || "warning",
  });
}

export function reportRespuestaError(component, error, options = {}) {
  const integrationError = handleIntegrationError(error, {
    openModal: options.showModal ? component.props.openModal : undefined,
    flow: "respuesta",
    service: options.service || "checkout-transaction",
    endpoint: options.endpoint,
    refPayco: options.refPayco,
    backendMessage: options.backendMessage,
    userMessage: options.userMessage,
    modalType: options.modalType || "warning",
  });

  if (options.setComponentState !== false) {
    component.setState({
      loadingTransaction: false,
      errorPago: true,
      integrationErrorMessage: integrationError.userMessage,
      ...(options.statePatch || {}),
    });
  }

  return integrationError;
}

export function handleIntegrationErrorWithRetry(error, options = {}) {
  const { onRetry, retryLabel = "Reintentar" } = options;
  const integrationError = handleIntegrationError(error, options);

  if (integrationError.retryable && onRetry && options.setModal) {
    options.setModal({
      open: true,
      message: integrationError.userMessage,
      tipo: options.modalType || "warning",
      actions: [
        {
          label: retryLabel,
          action: onRetry,
        },
      ],
    });
  }

  return integrationError;
}
